import { Box, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import { RiPhoneFill } from "react-icons/ri";

type PhoneData = {
	id: string;
	numero: string;
	obs: string;
	emp_cod: string;
}
type ItemPhoneProps = {
	phone: PhoneData;
	setPhoneModal: (phone: PhoneData) => void;
	setIsNewPhoneClienteModal: (isOpen: boolean) => void;
	phones: PhoneData[];
	setPhones: (enderecos: PhoneData[]) => void;
}

const ItemPhone: React.FC<ItemPhoneProps> = ({
	phone,
	setPhoneModal,
	setIsNewPhoneClienteModal,
	phones,
	setPhones,
}) => {
	function handleDeletePhone() {
		const phoneIndex = phones.findIndex(pho => pho.id === phone.id);
		phones.splice(phoneIndex, 1);
		setPhones([...phones]);
	}

	return (
		<Flex
			align="center"
			justify="space-between"
			bg="gray.40"
			borderColor="gray.100"
			borderWidth={1}
			borderRadius={8}
			py="2"
			px="4"
			_hover={{ boxShadow: 'lg' }}
		>
			<Flex
				w="100%"
				align="center"
				cursor="pointer"
				onClick={() => {
					setPhoneModal(phone);
					setIsNewPhoneClienteModal(true);
				}}
			>
				<Icon as={RiPhoneFill} fontSize="26" mr="4" color="gray.600" />
				<Box>
					<Text color="gray.600" fontSize="15">{phone.numero}</Text>
					<Text color="gray.500" fontSize="14">{phone.obs}</Text>
				</Box>
			</Flex>

			<Stack direction="row" spacing={4}>
				<Icon
					as={FiEdit3}
					w={6}
					h={6}
					cursor="pointer"
					color="blue.400"
					onClick={() => {
						setPhoneModal(phone);
						setIsNewPhoneClienteModal(true);
					}}
				/>

				<Icon
					as={FiTrash2}
					w={6}
					h={6}
					cursor="pointer"
					color="red.500"
					onClick={handleDeletePhone}
				/>
			</Stack>
		</Flex>
	);
}

export default ItemPhone;